import { useState } from "react";
import Chatbot from "./Chatbot";

import chatbot from "./assets/chatbot.webp";
import xyne from "./assets/xyne.png";

const styles = {
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        gap: "12px",
        zIndex: 1000,
    },
    panel: {
        width: "360px",
        maxWidth: "90vw",
        height: "500px",
        maxHeight: "75vh",
        background: "#fff",
        borderRadius: "16px",
        boxShadow: "0 8px 30px rgba(0, 0, 0, 0.2)",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
    },
    toggle: {
        border: "none",
        background: "transparent",
        padding: 0,
        cursor: "pointer",
        animation: "floatUpDown 2.5s ease-in-out infinite",
    },
    toggleImg: {
        height: "60px",
        width: "auto",
        display: "block",
    },
};

export default function FloatingChatbot() {
    const [open, setOpen] = useState(false);

    return (
        <div style={styles.root} className="floating-chatbot-root">
            <style>
                {`
                    @keyframes floatUpDown {
                        0%   { transform: translateY(0px); }
                        50%  { transform: translateY(-8px); }
                        100% { transform: translateY(0px); }
                    }

                    /* Desktop / default: bottom-right corner, panel stacked above the button */
                    .floating-chatbot-root {
                        position: fixed;
                        bottom: 24px;
                        right: 40px;
                        left: auto;
                        top: auto;
                        transform: none;
                        flex-direction: column;
                    }

                    /* Mobile: horizontally centered, near the top, panel opens below the button */
                    @media (max-width: 768px) {
                        .floating-chatbot-root {
                            position: fixed;
                            top: 16px;
                            bottom: auto;
                            left: 50%;
                            right: auto;
                            transform: translateX(-50%);
                            align-items: center;
                            flex-direction: column-reverse;
                        }
                    }

                    /* 👇 Lower chatbot button image size for narrower screens */
                    @media (max-width: 480px) {
                        .floating-chatbot-root .floating-chatbot-toggle-img {
                            height: 46px !important;
                            /* matches the intended downscaling, can tweak as needed */
                        }
                    }
                `}
            </style>

            {open && (
                <div style={styles.panel}>
                    <Chatbot onClose={() => setOpen(false)} />
                </div>
            )}

            <button
                style={styles.toggle}
                onClick={() => setOpen((prev) => !prev)}
                aria-label={open ? "Close chat" : "Open chat"}
            >
                <img
                    src={xyne}
                    alt=""
                    style={styles.toggleImg}
                    className="floating-chatbot-toggle-img"
                />
            </button>
        </div>
    );
}
